import { useTranslation } from 'react-i18next';

import { formatCurrency } from 'support/helpers/currency/currency';

type HeaderProps = {
  amount: number;
  currency: string | undefined;
};

export function Header({ amount, currency }: HeaderProps) {
  const { t } = useTranslation();

  return (
    <div className="mb-6 flex w-full flex-col items-center gap-2">
      <h2 className="text-xs font-normal leading-4 text-gray-500">{t('orderForms:checkout.totalAmount')}</h2>
      <h2 className="mb-3 text-3xl font-extrabold leading-8 text-gray-900">{formatCurrency(amount, currency)}</h2>
    </div>
  );
}
